import { ExternalLink } from 'lucide-react'

interface PDFViewerProps {
  url: string
  title: string
}

const PDFViewer = ({ url, title }: PDFViewerProps) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="btn-primary"
      aria-label={`Ouvrir le PDF ${title}`}
    >
      <ExternalLink className="w-4 h-4" />
      Ouvrir le PDF
    </a>
  )
}

export default PDFViewer

